import './Settings.scss'
import Button from "../util/Button.jsx";
import {useDispatch, useSelector} from "react-redux";
import Toggle from "../util/Toggle.jsx";
import AssetSelector from "../util/asset-selector/AssetSelector.jsx";
import {
    getComparativeAssetId,
    getDustThreshold,
    getIsAssetListCompositionBarVisible,
    getIsDustFiltered,
    getIsHotAssetsVisible,
    setComparativeAssetId,
    setDustThreshold,
    setIsAssetListCompositionBarVisible,
    setIsDustFiltered,
    setIsHotAssetsVisible
} from "../../ducks/assets-duck.js";
import {DECIMAL_FORMAT, numberFormat} from "../../util/numbers.js";

const DUST_THRESHOLDS = [10, 1_000, 5_000, 10_000, 50_000, 100_000]

export default () => {

    const dispatch = useDispatch()
    const comparativeAssetId = useSelector(getComparativeAssetId)
    const isDustFiltered = useSelector(getIsDustFiltered)
    const isAssetListCompositionBarVisible = useSelector(getIsAssetListCompositionBarVisible)
    const isHotAssetsVisible = useSelector(getIsHotAssetsVisible)
    const dustThreshold = useSelector(getDustThreshold)

    return (
        <div className='settings'>
            <h2>
                Settings
            </h2>
            <h3>Assets</h3>
            <div className='toggle-container'>
                <Toggle
                    isChecked={isHotAssetsVisible}
                    onChange={() => dispatch(setIsHotAssetsVisible(!isHotAssetsVisible))}
                >
                    Hot assets <span className='weak'> rate changes >1.5% within 1 hour</span>
                </Toggle>
            </div>
            <div className='toggle-container'>
                <Toggle
                    isChecked={isAssetListCompositionBarVisible}
                    onChange={() => dispatch(setIsAssetListCompositionBarVisible(!isAssetListCompositionBarVisible))}
                >
                    Asset list change visualization
                </Toggle>
            </div>
            <div className='toggle-container flex-vertical-center dust'>
                <Toggle
                    isChecked={isDustFiltered}
                    onChange={() => dispatch(setIsDustFiltered(!isDustFiltered))}
                >
                    Filter out dust assets <span className='weak'> value &lt; kr {numberFormat(dustThreshold)}</span>
                </Toggle>
                {isDustFiltered &&
                <div className='flex-vertical-center hide-portrait dust-thresholds'>
                    {DUST_THRESHOLDS.map(threshold =>
                        <Button key={threshold} isChecked={dustThreshold === threshold}
                                onClick={() => dispatch(setDustThreshold(threshold))}>
                            {numberFormat(threshold, DECIMAL_FORMAT.FLEX_INT)}
                        </Button>
                    )}
                </div>
                }
            </div>
            <AssetSelector
                headerSelected={'Comparative base asset'}
                selectedAssetId={comparativeAssetId}
                selectAsset={assetId => dispatch(setComparativeAssetId(assetId))}
                isScrollable={true}
            />
        </div>
    )
}